<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-configuration-topics">
    <div class="configuration-topics-header" v-bind:class="{'isDisabled': loading}">
      <el-input placeholder="Search conversation topics" ref="searchBarInput" class="search-input" v-model="searchInput" @keyup.native="handleKeypress" :disabled="!topicListOriginal || topicListOriginal.length==0"></el-input>
      <el-tooltip v-if="isRoleAllow([4201, 900011])" class="item" effect="dark" content="Group Topics" placement="bottom">
        <el-button class="el-merge-topic" @click="handleMergeTopics" :disabled="!enableMergeTopics"></el-button>
      </el-tooltip>
      <el-tooltip v-if="isRoleAllow([4201, 900011])" class="item" effect="dark" content="Add to Blacklist" placement="bottom">
        <el-button class="el-black-list" @click="handleBlackList" :disabled="!enableBlackList"></el-button>
      </el-tooltip>
      <el-tooltip v-if="isRoleAllow([4201, 900011])" ref="reloadCurrentPage" popper-class="reloadCurrentPage" class="item" effect="dark" content="Data Updated: Please click here to refresh the conversation topics" placement="bottom">
        <el-button class="el-reload" @click="handleReloadCurrentPage" :disabled="!enableReloadCurrentPage"></el-button>
      </el-tooltip>
    </div>
    <div class="configuration-topics-content" v-loading="loading">
      <div class="topic-group-section">
        <div class="div-group-viewer-content">
          <div class="div-group-topics" v-bind:class="{'isDisabled': loadingMsg}">
            <div class="div-topic-content" v-bind:class="{'isTableEditing': isTableEditing}" >
              <!-- <div class="div-item" :title="topic.topicDisplayName" v-for="(topic) in groupTopics" :label="topic" :key="topic.Name" :class="{selected: selectedTopic && selectedTopic.topicDisplayName==topic.topicDisplayName}" @click="getMessagesByTopics(topic)">
                <div class="div-ellipsis-item">{{topic.topicDisplayName}}</div> 
                <i v-if="isRoleAllow(4201)" class="el-icon-error" @click="removeTopic(topic, $event)"></i>
              </div> -->

              <el-table
                v-if="tableData && tableData.length > 0"
                ref="configTopicsTable"
                :data="tableData"
                highlight-current-row
                @row-click="getMessagesByTopics"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                >
                <el-table-column
                  class-name="topic-check-box"
                  type="selection"
                  width="40">
                </el-table-column>
                <el-table-column
                  property="topicDisplayName"
                  label="Conversation Topics"
                  class-name="topic-name"
                  width="290">
                   <template slot-scope="scope">
                      <!-- <div class="div-ellipsis-item" :title="scope.row.topicDisplayName">
                       {{ scope.row.topicDisplayName }}
                      </div> -->
                      <div class="wy-table-editor" v-bind:class="{'isEditing': scope.row.isEditing, 'highlightedRow': scope.$index == highlightedIndex}" @mouseover="handleMouseover(scope)" @mouseleave="handleMouseleave(scope)">
                        <el-input v-if="scope.row.isEditing" class="wy-table-content" type="text" v-model="editingValue" @blur="handleEditingBlur($event, 'topicDisplayName', scope.row)" @click="handleClickInput"  @keypress.native="handleKeyDown"></el-input>
                        <span v-else class="wy-table-content" :title="scope.row.topicDisplayName">{{scope.row['topicDisplayName']}}</span>
                        <span v-if="isRoleAllow([4201, 900011])" class="el-edit-icon el-edit-pencil" @click="handleEditing($event, 'topicDisplayName', scope.row, true)" 
                          @mouseover="handleTooltipOver($event, 'Edit Topic Name')" @mouseout="handleTooltipOut($event)"></span>
                        <!-- <span v-if="isRoleAllow([4201, 900011])" class="el-edit-icon el-edit_confirm" @click="handleEditingConfirm($event, 'topicDisplayName', scope.row)"></span> -->
                        <span v-if="isRoleAllow([4201, 900011])" class="el-edit-icon el-edit-cancel" @click="handleEditing($event, 'topicDisplayName', scope.row, false)">Cancel</span>
                      </div>
                  </template>
                </el-table-column>
                <el-table-column
                  property="volume"
                  label="Volume"
                  class-name="volume-number"
                  width="70">
                </el-table-column>
              </el-table>
              <!-- <div v-else class="no-data">
                <div class="no-data-icon"></div>
                <div class="no-data-title">Sorry!</div>
                <div class="no-data-content">
                  No data available yet for this brand or time period. Please use the global filter to select a brand and time period with data available.
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="showMessageContent" class="topic-messages-section">
        <div class="div-topic-messages-viewer-header">Conversations</div>
        <div class="div-topic-messages-viewer-content" v-loading="loadingMsg">
          <div ref="conversationMessages" class="div-topic-message-name" v-for="(message, index) in topicMessages" :key="index" :class="{selected: selectedMessage && (selectedMessage.conversationId == message.conversationId)}" @click="getTranscriptById(message)">
            <div class="message-date">{{formatMessageHeaderDate(message.date)}}</div>
            <div class="message-right">
              <div class="message-date-time">
                {{getTimeRange(message)}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <wy-analytics-transcript-viewer v-if="(showMessageContent && topicMessages && topicMessages.length > 0) || loadingMsg" :parent="module" :messagesTranscripts="messageTranscripts" :selectedMessage="selectedMessage" :loading="loadingMsg" :fromConfiguration="true" viewName="Conversation Topics"/>

      <!-- <div v-if="showUndoBlackListSuccess" role="alert" class="el-message el-message--warning undo-blacklist-success-message">
        <p class="el-message__content">BlackList is removed successfully.</p>
      </div> -->
    </div>
    
    <wy-analytics-contact-reasons-black-list ref="blacklist" :controller="module" componentName="wy-analytics-configuration-topics" />
    <wy-analytics-contact-reasons-merge-topics ref="mergeTopics" :controller="module" componentName="wy-analytics-configuration-topics" />
    <wy-analytics-contact-reasons-update-topic ref="duplicateTopicName" :controller="module" />
    <el-dialog
      title=""
      v-if="dialogMergeWaitingVisible"
      :visible.sync="dialogMergeWaitingVisible"
      :close-on-click-modal="true"
      :show-close="false"
      :close-on-press-escape="false"
      append-to-body
      custom-class="mergeWaitingDialog"
      :before-close="closeWaiting">
      <div class="new-waithing-icon"></div>
      <div class="waiting-msg">Changes succesfully made! We are updating your data...</div>
      <div class="waitting-msg-content">This process usually takes a few minutes, your changes to Conversation Topics won’t appear right away.</div>
      <div class="dialog-footer">
        <el-button class="btn-confirm active" type="primary"  @click="closeWaiting">OK</el-button>
      </div>
    </el-dialog>
    <el-tooltip
      ref="tableTooltip"
      placement="bottom"
      effect="dark"
      :content="tableTooltipContent">
    </el-tooltip>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import WyUtils from '../../../library/wy-utils.js';
  import WyAnalyticsContactReasonsMergeTopics from '../wy-analytics-contact-reasons-merge-topics';
  import WyAnalyticsContactReasonsBlackList from '../wy-analytics-contact-reasons-black-list';
  import wyAnalyticsContactReasonsUpdateTopic from '../wy-analytics-contact-reasons-update-topic'
  import WyAnalyticsTranscriptViewer from '../wy-analytics-transcript-viewer.vue';


  export default Vue.extend({
    name: 'wy-analytics-configuration-topics',
    components: {
      'wy-analytics-contact-reasons-merge-topics': WyAnalyticsContactReasonsMergeTopics,
      'wy-analytics-contact-reasons-black-list': WyAnalyticsContactReasonsBlackList,
      'wy-analytics-contact-reasons-update-topic': wyAnalyticsContactReasonsUpdateTopic,
      'wy-analytics-transcript-viewer': WyAnalyticsTranscriptViewer
    },
    title: 'Configuration',
    props: ['controller'],
    data() {
      return {
        module: this,
        loading: false,
        loadingMsg: false,
        initDate: null,
        groupName: null,
        groupTopics: [],

        checkAll: true,
        isIndeterminate: false,
        checkedTopics: [],
        topicData: {},
        topicMessages: [],
        messageTranscripts: [],

        multipleSelection: [],
        // enableMergeTopics: false,
        // enableBlackList: false,

        selectedTopic: null,
        selectedMessage: null,

        showMessageContent: false,
        showTranscriptContent: false,

        dialogMergeWaitingVisible: false,

        // dialogBlackListWaitingVisible: false,
        // showUndoBlackListSuccess: false,
        preMsgObj: null,

        topicListOriginal: [],
        // searchInput: '',
        searchInput: '',
        searchTimeout: null,

        isTableEditing: false,
        editingValue: '',
        tableTooltipContent: '',
        highlightedIndex: -1,
        processStatusInfo: {},

        enableReloadCurrentPage: false
      }
    },

    watch: {
      updatedProcessList() {
        // if there is finished process, enable relaod the current page button
        if(this.controller.activeTab == "topics") {
          if(this.updatedProcessList.find(process => process.processStatus == "finished")) {
            this.enableReloadCurrentPage = true;
            this.$refs.reloadCurrentPage.show();
          }
        }
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'isRoleAllow', 'updatedProcessList', 'transcriptInfoReference']),

      enableMergeTopics() {
        return this.multipleSelection.length > 1;
      },

      enableBlackList() {
        return this.multipleSelection.length > 0;
      },

      tableData() {
        let list = null;
        if(this.searchInput && this.searchInput!='') {
          list = this.topicListOriginal.filter(topic => topic.topicDisplayName.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1);
        }
        else {
          list = this.topicListOriginal;
        }
        return list
      }
    },
    
    methods: {
    ...mapActions(['fetchAllContactReasons', 'fetchContactReasonsTopicConversationsWithoutFilters', 'fetchContactReasonsTopicConversationDetail', 'updateTopicName']),
    ...mapMutations(['updateTranscriptInfoReference']), //handle transcript info

    handleTranscriptPopover() {
      if (this.transcriptInfoReference) {
        this.transcriptInfoReference.visible = false;
        this.updateTranscriptInfoReference(null);
      }
    },

    handleEditing(e, column, row, isEditing) {
        e.preventDefault();
        e.stopPropagation();
        row.isEditing = isEditing;
        this.isTableEditing = isEditing;
        this.editingValue = isEditing ? row[column] : null;
        this.highlightedIndex = null;

        setTimeout(() => {
          let inputEl = e.target.parentNode.querySelector("input.wy-table-content");
          if (inputEl && inputEl.setSelectionRange) {
              inputEl.setSelectionRange(0, 0);
              inputEl.focus();
          }
        }, 100)
      },

      handleTimeInNiceFormat(Millis){
        let seconds = Millis/1000;
        
        return WyUtils.toNiceTimeFormat(seconds);
      },

      handleTooltipOver(e, content) {
        this.$refs.tableTooltip.hide();
        this.$refs.tableTooltip.handleClosePopper();
        this.$refs.tableTooltip.referenceElm = e.target;
        this.tableTooltipContent = content;
        setTimeout(() => {
          let rect = this.$refs.tableTooltip.referenceElm.getBoundingClientRect();
          if(rect.top > 0) {
            this.$refs.tableTooltip.show();
            this.$refs.tableTooltip.handleShowPopper();
          }
        }, 300)
      },

      handleTooltipOut() {
        this.$refs.tableTooltip.hide();
        this.$refs.tableTooltip.handleClosePopper();
      },

      //  handleClick(e, rowIndex, row) {
      //     let target = e.target;
      //     if(!this.isTableEditing && !target.classList.contains("wy-table-select") && !target.parentNode.classList.contains("wy-table-select")) {
      //       this.rowClickEvent(rowIndex, row);
      //     }
      //   },

      handleEditingConfirm(e, column, row) {
        e.preventDefault();
        e.stopPropagation();
        if(this.editingValue) {
          row.isEditing = false;
          this.isTableEditing = false;
          if(row[column] != this.editingValue.trim()) {
            this.updateTableData(row, column, this.editingValue.trim());
          }        
        }
      },

      handleEditingBlur(e, column, row) {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
          if(row.isEditing && this.editingValue) {
            this.handleEditingConfirm(e, column, row);
          }
        }, 200)
      },

      handleKeyDown(event) {
        if(event.keyCode === 13) {
          event.target.blur();
        }
      },

      handleClickInput(e) {
        e.preventDefault();
        e.stopPropagation();
      },

      handleMouseover(scope) {
        if(!this.isTableEditing) {
          this.highlightedIndex = scope.$index;
        }
      },

      handleMouseleave() {
        this.highlightedIndex = null;
      },

      closeWaiting() {
        this.dialogMergeWaitingVisible = false;
      },

      async updateTableData(row, columnName, newValue, callback) {
        let topicNameObject = {
          oldTopicDisplayName: row[columnName],
          newTopicDisplayName: newValue,
        }

        this.loading = true;
        const res = await this.updateTopicName(topicNameObject);
        this.loading = false;

        if(!res) {
          this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
        }
        else if(res.status == 200) {
          this.$root.showProcessWaitDialogue({visible: true, processId: res.data.processId});

          if(callback) callback({error: false});

          // update detail page subtitle          
          if(this.$refs.detailPage) {
            this.$refs.detailPage.handleCloseEditTopic();
          }
        }
        else if(res.status == 409) {
          if(callback) callback({error: true});
          
          if(res.data.errorCode == 4013) {
            this.$refs.duplicateTopicName.handleOpen(row, topicNameObject);
          }
          else {
            this.$root.showProcessErrorDialogue({controller: this, info: res.data});
          }        
        }
      },

      async handleSearch() {
          let list = JSON.parse(JSON.stringify(this.topicListOriginal));
          this.groupTopics = list.filter(topic => topic.topicDisplayName.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1);
      },

      handleKeypress() {
          if(this.searchTimeout) {
              clearTimeout(this.searchTimeout)
          }
          this.searchTimeout = setTimeout(()=>{ 
              this.handleSearch();
          }, 1000);
      },

      handleSelectionChange(rows) {
        this.multipleSelection = rows;
      },

      handleMergeTopics() {
        let selectedList = JSON.parse(JSON.stringify(this.multipleSelection));
        this.$refs.mergeTopics.handleMergeTopicsOpen(selectedList)
      },

      handleBlackList() {
        let selectedList = JSON.parse(JSON.stringify(this.multipleSelection));
        this.$refs.blacklist.handleBlackListOpen(selectedList);
      },

      handleReloadCurrentPage() {
        this.loadTopics();        
      },

      async getMessagesByTopics(topic) {
        this.showMessageContent = true;
        let topics = topic.mergedTopics;
        this.selectedTopic = topic;
        this.topicMessages = [];
        this.showTranscriptContent = false;
        this.loadingMsg = true;
        // this.messageTranscripts = [];
        let result = await this.fetchContactReasonsTopicConversationsWithoutFilters({from: 'topicGroup', topics: topics, topicDisplayName: topic.topicDisplayName})
        
        if(result && result.data && result.data.length > 0) {
          await this.getTranscriptById(result.data[0]);

          this.topicMessages = result.data;
          // this.messageTranscripts = this.topicMessages[0].messages;
          // this.selectedMessage= this.topicMessages[0];
          this.showTranscriptContent = true;          
        }
        else {
          this.topicMessages = [];
          this.messageTranscripts = [];
          this.showTranscriptContent = false;
        }
        this.loadingMsg = false;
      },

      async getTranscriptById(item) {
        this.messageTranscripts = [];
        this.showTranscriptContent = false;

        let resultDetail = await this.fetchContactReasonsTopicConversationDetail({ conversationId: item.conversationId })
        if(resultDetail && resultDetail.data) {
          this.selectedMessage = resultDetail.data;
          this.messageTranscripts = this.selectedMessage.messages;
        }
      },

      async loadTopics() {
        this.enableReloadCurrentPage = false;
        this.showMessageContent = false;
        this.showTranscriptContent = false;
        this.loading = true;
        let result = await this.fetchAllContactReasons();
        if(result && result.data && result.data.length > 0) {
          this.groupTopics = result.data;
          this.groupTopics.forEach(groupTopic=>{
            groupTopic.isEditing = false
          })
          this.topicListOriginal = JSON.parse(JSON.stringify(this.groupTopics));
        }
        this.loading = false;
      },

      formatMessageHeaderDate(date) {
        return WyUtils.formatDateWithDay(date);
      },

      formatMessageDate(date) {
        return WyUtils.formatDate(date);
      },

      getTimeRange(transcript) {
        if(transcript.msgTime) {
          return transcript.msgTime
        }
        else {
          // TODO: This is for V2 API and can be removed later 
          return WyUtils.getTimeRange(transcript);
        }
      },
      
      toTranscriptLabel(val) {
        return WyUtils.toTranscriptLabel(val);
      }
    },

    async created() {
      // this.dataModel.filters.topics.value = topics;          
      // this.loadTopics();
    },

    mounted() {
    
    // on scroll, we close the transcript popover & any opened dropdowns
    document.querySelector('.wy-analytics-configuration .el-tabs__content').addEventListener('scroll', () => {
      this.handleTranscriptPopover();
    });

    
  }
  });
</script>

<style lang="scss">

.contact-reason-group-topics-tab-info-pop-over{
  background: black;
  line-height: 18px;
  color: #E4E8EC;
  border-color: var(--site-font-chart-color) !important;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  .popper-item{
    margin-bottom: 15px;
  }
  .popper__arrow:after{
  display: block !important;
  border-bottom-color: #000 !important;
  }

}
.wy-analytics-configuration-topics {
  // display: inline-flex;
  //margin: 5px 0px 0px 25px;
  width: 100%;
  // height: calc(98vh - 258px);
  height: 100%;
  min-width: 1093px;
  .transcripts-viewer-header-right {
    overflow-y: auto;
    height: 204px !important;
    padding-right: 20px;

    &::-webkit-scrollbar {
      background-color: #000 !important;
      width: 8px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #C8C8C8 !important;
      border-radius: 5px;
    }
  }
  .contact-reason-transcript-tab-info-pop-over{
    padding: 12px 7px 10px 15px !important;
  }

  .popper__arrow:after{
    display: block !important;
    border-bottom-color: #000 !important;
  }
  .configuration-topics-header {
    padding-top: 5px;
    padding-bottom: 5px;

    .search-input {
      display: inline-flex;
      width: 220px;
      height: 24px;
      top: -10px;
      padding-right: 7px;

      input.el-input__inner {
        height: 24px;
        padding-bottom: 0px;
        border: 1px solid #B3B3B3 !important;
        border-radius: 15px;
        padding-left: 15px;
      }
    }
    .el-black-list {
      cursor: pointer;
      background-image: url('../../../assets/icons/icon_blacklist.svg') !important;
      background-size: 55%;
      background-repeat: no-repeat;
      background-position-y: 4px;
      background-position-x: 5px;
      height: 24px;
      width: 24px;
      border: 0px;
      background-color: transparent;
      padding: 0px;
      margin-left: 4px;
    }
    .el-black-list:hover {
      // background-image: url('../../assets/icons/icon_blacklist_hover.svg');
      background-color: #ebf4fd;
      background-position-y: 4px;
      background-position-x: 5px;
    }
    button.el-button.el-tooltip.el-black-list.item.el-button--default.is-disabled {
      background-color: transparent;
      cursor: not-allowed;
    }
    .el-reload {
      cursor: pointer;
      background-image: url('../../../assets/icons/icon_reload.svg') !important;
      background-size: 55%;
      background-repeat: no-repeat;
      background-position-y: 4px;
      background-position-x: 5px;
      height: 24px;
      width: 24px;
      border: 0px;
      background-color: transparent;
      padding: 0px;
      margin-left: 4px;
    }
    .el-reload:hover {
      // background-image: url('../../assets/icons/icon_blacklist_hover.svg');
      background-color: #ebf4fd;
      background-position-y: 4px;
      background-position-x: 5px;
    }
    button.el-button.el-tooltip.el-reload.item.el-button--default.is-disabled {
      background-color: transparent;
      cursor: not-allowed;
    }
    .el-merge-topic {
      cursor: pointer;
      background-image: url('../../../assets/icons/icon_merged.svg') !important;
      background-size: 50%;
      background-repeat: no-repeat;
      background-position-y: 4px;
      background-position-x: 7px;
      height: 24px;
      width: 24px;
      border: 0px;
      margin-left: 0px !important;
      background-color: transparent;
      padding: 0px;
    }
    .el-merge-topic:hover {
      // background-image: url('../../assets/icons/icon_flow_branch_hover.svg');
      background-color: #ebf4fd;
      background-position-y: 4px;
      background-position-x: 7px;
    }
    button.el-button.el-tooltip.el-merge-topic.item.el-button--default.is-disabled {
      background-color: transparent;
      cursor: not-allowed;
    }
  }
  .isDisabled {
    pointer-events: none;
    opacity: 0.4;
  }
  .configuration-topics-content {
    display: -webkit-inline-box;
    display: inline-flex;
    height: calc(100% - 40px);
    overflow-y: hidden;
    position: relative;
    right: 10px;
    overflow-x: hidden;
    .topic-group-section {
      //margin: 20px 0px 20px 0px;
      width: 415px;
      margin-right: 15px;
      // width: 25%;
      padding: 0px 0px 0px 0px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #E8E8E8;
      border-radius: 15px;
      opacity: 1;
      overflow: hidden;

      .div-group-viewer-content {
        margin-top: 0px;
        // border-top: 1px solid #E8E8E8;
        height: calc(100% - 0px);
        overflow-y: auto;
        overflow-x: hidden;
        margin-bottom: 12px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      .div-group-viewer-header.div-group-name {
        font-size: 16px;
        font-weight: 500;
        padding: 0px 10px 0px 30px;
      }
      .div-group-topics {

        .div-topic-content {
          height: fit-content;
          .el-table th {
            padding:12px 0;
          }
          .el-table td {
            padding: 6px 0 4px 0;
            cursor: pointer;
            border-bottom: 0;
          }
          .el-table td.topic-check-box {
            padding: 8px 0 4px 0;
          }
          .el-table tr.current-row>td {
            background-color: #E2ECF7;
          }
          .el-table--enable-row-hover .el-table__body tr:hover>td {
            background-color: #f5f7fa;
          }
          .el-table--fit {
            // border-radius: 15px;
          }
          .topic-check-box .cell {
            text-overflow: unset;
            padding-left: 15px; 
            margin-bottom: 3px;
          }
          th.topic-name .cell {
            width: 100%;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: var(--site-font-primary-color);
            font-size: 15px;
            font-weight: 500;
          }
          th.volume-number .cell {
            text-align: right;
            color: var(--site-font-primary-color);
            font-size: 15px;
            font-weight: 500;
            padding-right: 5px;
          }
          td.topic-name {
            color: var(--site-font-primary-color);
            padding: 4px 0 4px 0;
            .div-ellipsis-item {
              width: 100%;
              font-size: 12px;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .wy-table-editor {
              padding: 0;
              width: 100%;
              display: flex;
              align-items: center;
            }

            .wy-table-editor.isEditing {
              pointer-events: none;
              .el-edit-cancel {
                display: inline-block;
                width: 63px;
                color: #106FBC;
              }
              .el-edit_confirm {
                display: inline-block;
              }
              .el-edit_confirm::after {
                content: '|';
                font-size: 20px;
                font-weight: 200;
                color: #ddd;
                text-shadow: 0 0 2px #ddd;
                position: absolute;
                right: -2px;
                top: 1px;
              }
              .wy-table-content {
                display: inline-block;
                width: 285px;
                padding: 3px 10px;
                padding-right: 0px;
                border-radius: 4px;
                pointer-events: initial;
                .el-input__inner {
                  background-color: #FFF;
                  border-radius: 4px;
                  border: 1px solid #DCDFE6;
                  position: relative;
                  right: 10px;
                  height: 25px;
                  &:focus-within{
                    border: 1px solid #106FBC;
                  }
                }
                input.el-input__inner {
                border-width: 1px !important;
                }
              }
            }
            .isTableEditing {
              .el-edit-pencil {
                display: none !important;
              }
            }
            .highlightedRow {
              .el-edit-pencil {
                display: block;
              }
            }

            .wy-table-content {
              display: inline-block;
              border: 1px solid transparent;
              vertical-align: middle;
              margin-right: auto;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 250px;
            }

            .el-edit-icon  {
              display: none;
              cursor: pointer;
              background-size: 11px;
              background-repeat: no-repeat;
              background-position-y: 4px;
              background-position-x: 7px;
              background-color: transparent;
              border-radius: 16px;
              height: 20px;
              width: 20px;
              position: relative;
              left: 5px;
              top: 0px;
              vertical-align: middle;
              pointer-events: initial;
            }

            .el-edit-pencil {
              background-image: url('../../../assets/icons/icon_edit_pencil.svg') !important;
              background-position-x: 4px;
              
            }
            .el-edit-pencil:hover {
              background-color: #ebf4fd;
            }

            .el-edit-cancel {
              // background-image: url('../../../assets/icons/icon_topic_cancel.svg') !important;
              // background-position-x: 4px;
            }
            .el-edit-cancel:hover {
              background-color: unset!important;
            }

            .el-edit_confirm {
              background-image: url('../../../assets/icons/icon_topic_confirm.svg') !important;
              background-position-x: 1px;
              background-position-y: 5px;
            }
            .el-edit_confirm:hover {
              background-color: #ebf4fd !important;
            }

            .el-edit_confirm::after {
              content: '|';
              font-size: 15px !important;
              top: -4px!important;
            }
          }
          //======================
          td.volume-number {
            color: var(--site-font-primary-color);
            text-align: right;
            font-size: 12px;
            padding-bottom: 2px;
          }
          .div-item {
            color: var(--site-font-primary-color);
            font-weight: normal;
            margin: 0px 0px 5px 0px;
            line-height: 19px;
            padding: 15px 10px 5px 30px;
            font-size: 12px;
            cursor: pointer;
            .div-ellipsis-item {
              width: 88%;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .div-item:hover {
            background: #f5f7fa;
          }
          .div-item.selected {
            background:  #E2ECF7 !important;
          }

          .el-icon-error{
            float: right;
            // display: none;
            top: 4px;
            left: -10px;
            position: relative;
            color: #80A6CD;
            cursor: pointer;
            font-size: 15px;
          }
          .el-icon-error.is-disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
          .div-item:hover .el-icon-error {
            display: block; 
          }
          .el-table__header-wrapper{
            .el-table__header{
              width: 100% !important;
            }
          }
          .el-table__body-wrapper{
            overflow-x: hidden;
          }
          .el-table::before {
              height: 0px;
          }
        }
      }
    }

    .topic-messages-section {
      //margin: 20px 0px 20px 15px;
      width: 335px;
      // width: 30%;
      padding: 9px 0px 10px 0px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #E8E8E8;
      border-radius: 15px 0px 0px 15px;
      opacity: 1;
      height: calc(100% - 22px);

      .div-topic-messages-viewer-header {
        font-size: 15px;
        font-weight: 500;
        position: relative;
        top: 3px;
        padding: 6px 10px 6px 30px;
      }
      .div-topic-messages-viewer-content {
        margin-top: 15px;
        border-top: 1px solid #E8E8E8;
        height: calc(100% - 36px);
        overflow-y: auto;
        width: 335px;
        overflow-x: hidden;
        margin-bottom: 20px;
        // padding-top: 10px;

        .div-topic-message-name {
          font-size: 12px;
          word-break: keep-all;
          cursor: pointer;
          color: var(--site-font-primary-color);
          font-weight: normal;
          margin: 0px 0px 0px 0px;
          line-height: 18px;
          padding: 13px 10px 11px 30px;
          .message-date {
            width: 110px;
            display: inline-block;
          }
          .message-right {
            float: right;
            width: 130px;
            .message-date-time {
              text-align: left;
              padding-right: 10px;
            }
          }
        }
        .div-topic-message-name:hover {
          background: #f5f7fa;
        }
        .div-topic-message-name.selected {
          background: #E2ECF7;
        }
        .el-loading-mask {
          bottom: 12px;
          .el-loading-spinner {
            top: 35%;
            background: var(--site-loading-icon);
            background-repeat: no-repeat;
            background-size: 25px;
            background-position: center;    
            .circular {
              display: inline-block;
              width: 90px;
              height:  90px; 
            }
          }
          .el-loading-spinner .path {
            -webkit-animation: loading-dash 2s ease-in-out infinite;
            animation: loading-dash 2s ease-in-out infinite;
            stroke-dasharray: 90,150;
            stroke-dashoffset: 0;
            stroke-width: 2.5 !important;
            stroke: #0C2837 !important;
            stroke-linecap: round;
            
          }
        }
      }  
    }
  }

  .el-message {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #FFF;
    position: fixed;
    left: 50%;
    top: 90px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color:#395167;
    -webkit-transition: opacity .3s,top .4s,-webkit-transform .4s;
    transition: opacity .3s,top .4s,-webkit-transform .4s;
    transition: opacity .3s,transform .4s,top .4s;
    transition: opacity .3s,transform .4s,top .4s,-webkit-transform .4s;
    padding: 15px 15px 15px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    // background: #FCFCFC 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #214586;
    border-radius: 15px;
    width: fit-content !important;
    min-width: unset;
  }
  .el-message .el-icon-warning {
    color: var(--site-font-primary-color) !important;
  }
  .el-message__icon {
      margin-right: 10px;
  }
  .el-icon-warning:before {
      content: "\E7A3";
  }
  .el-message--warning .el-message__content {
    color:#FFF !important;
    padding-right: 30px;
  }  
  .undo-merge-success-message .el-message__content {
    padding-right: 0px;
  }
  .el-message.undo-merge-message p {
    padding-right: 30px !important;
  }
  .el-message p {
    padding-right: 4px !important;
  }
  .el-message__content {
    padding: 0;
    font-size: 14px;
    line-height: 1;
  }
  .no-data {
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .no-data-icon {
      display: block;
      border: none;
      height: 155px;
      width: 155px;
      background-position-x: 50%;
      background-repeat: no-repeat;
      background-image: url(../../../assets/icons/icon_no_data_new.svg);
      margin-bottom: 10px;
    }
    .no-data-title {
      font-size: 21px !important;
      color: var(--site-font-tertiary-color) !important;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .no-data-content {
      font-size: 14px;
      color: #4B5158 !important;
      line-height: 22px;
      text-align: center;
    }
  }
  .message-transcripts-section {
    padding: 14px 0px 30px 0px;
    .div-message-transcripts-viewer-content {
      height: 97%;
      // border-top: 1px solid #e8e8e8;
    }
    .div-message-transcripts-viewer-header {
      .right-section {
        bottom: 6px !important;
        .saved-transcript-golden-star, .saved-transcript-grey-star {
          margin-top: 6px !important;
        }
      }
    }
  }
}

.el-tooltip__popper.reloadCurrentPage {
  background-color: #67c23a;
  .popper__arrow {
    border-bottom-color: #67c23a;
  }
  .popper__arrow::after {
    border-bottom-color: #67c23a;
  }
}
</style>